import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const QrSharingHelpSheet = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        aria-label="How to use your QR code"
        onClick={() => setOpen(true)}
        size="small"
        sx={{
          p: 0.35,
          color: "#6B7280",
          "&:hover": {
            bgcolor: "transparent",
            color: "#111",
          },
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 18 }} />
      </IconButton>

      <SwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        disableDiscovery
        PaperProps={{
          sx: {
            borderTopLeftRadius: 28,
            borderTopRightRadius: 28,
            px: 2.5,
            pb: 3,
            pt: 1.25,
            maxWidth: 560,
            mx: "auto",
          },
        }}
      >
        <Box
          sx={{
            width: 42,
            height: 4,
            borderRadius: 99,
            bgcolor: "#D1D5DB",
            mx: "auto",
            mb: 2.5,
          }}
        />

        <Typography sx={{ fontSize: 20, fontWeight: 800, color: "#111" }}>
          How do I use my QR code?
        </Typography>

        <Box sx={{ mt: 3, display: "grid", gap: 2.25 }}>
          <Box>
            <Typography sx={{ fontWeight: 700, color: "#111" }}>
              Need a sign fast?
            </Typography>
            <Typography sx={{ mt: 0.35, color: "#6B7280", lineHeight: 1.45 }}>
              Tap Create a Sign to make a QR sign you can print, text, or share
              digitally as a PNG.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, color: "#111" }}>
              Want to make your own design?
            </Typography>
            <Typography sx={{ mt: 0.35, color: "#6B7280", lineHeight: 1.45 }}>
              Screenshot this QR code, upload it to Canva, and add it to your
              invitation, welcome sign, table sign, or anything else.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, color: "#111" }}>
              Want to text or post it?
            </Typography>
            <Typography sx={{ mt: 0.35, color: "#6B7280", lineHeight: 1.45 }}>
              Screenshot the QR code to send it digitally, or tap Share to send
              your event link.
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 700, color: "#111" }}>
              What guests do
            </Typography>
            <Typography sx={{ mt: 0.35, color: "#6B7280", lineHeight: 1.45 }}>
              They scan the QR code and upload photos and Boomerangs!No app or
              login needed.
            </Typography>
          </Box>
        </Box>

        <Button
          fullWidth
          variant="contained"
          onClick={() => setOpen(false)}
          sx={{
            mt: 3,
            py: 1.35,
            borderRadius: 99,
            bgcolor: "#000",
            textTransform: "none",
            fontSize: 16,
            fontWeight: 700,
            boxShadow: "none",
            "&:hover": {
              bgcolor: "#111",
              boxShadow: "none",
            },
          }}
        >
          Got it
        </Button>
      </SwipeableDrawer>
    </>
  );
};

export default QrSharingHelpSheet;